 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"AccountOpening":"AccountOpening","BackTopBottom":"BackTopBottom","Caption":"Caption","Copyright":"Copyright","DataBox":"DataBox","HomeFooter":"HomeFooter","Img":"Img","LivePlayer":"LivePlayer","MoreTabs":"MoreTabs","Nav":"Nav","NormalCaption":"NormalCaption","Offline":"Offline","QQShare":"QQShare","Stick":"Stick","Tip":"Tip","ViewMoreLink":"ViewMoreLink","WxLaunchApp":"WxLaunchApp","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic","Atlas":"Atlas","FiveNavPic":"FiveNavPic","FourNavPic":"FourNavPic","ThreeNavPic":"ThreeNavPic","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage":"vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage","Hongbao":"Hongbao","NoImage":"NoImage","vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage":"vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage","BigImage":"BigImage","OneImage":"OneImage","ThreeImage":"ThreeImage","TwoImage":"TwoImage","vendors~NewsStream":"vendors~NewsStream","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7","BrowserGuideLayer":"BrowserGuideLayer","MarkTabs":"MarkTabs","PageBottomBrand":"PageBottomBrand","WXGuideLayer":"WXGuideLayer","MdBanner":"MdBanner","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg","BigImg":"BigImg","SingleTitle":"SingleTitle","SlideImg":"SlideImg","TwoImg":"TwoImg","vendors~BigTopic~InformationFlow~TitleImg":"vendors~BigTopic~InformationFlow~TitleImg","InformationFlow":"InformationFlow","BigTopic":"BigTopic","TitleImg":"TitleImg","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides","vendors~BottomSlides~UpgradeBottomSlides":"vendors~BottomSlides~UpgradeBottomSlides","UpgradeBottomSlides":"UpgradeBottomSlides","vendors~IndexSlides":"vendors~IndexSlides","vendors~CallupHead":"vendors~CallupHead","vendors~Comment~ShareComment":"vendors~Comment~ShareComment","vendors~ShareComment":"vendors~ShareComment","vendors~Player":"vendors~Player","vendors~Survey":"vendors~Survey","vendors~WxLaunchHack":"vendors~WxLaunchHack","Slides":"Slides","vendors~NormalSlides":"vendors~NormalSlides","vendors~ShareSlides":"vendors~ShareSlides","vendors~CallupVideoAppHead":"vendors~CallupVideoAppHead","vendors~Comment~LoginDialog":"vendors~Comment~LoginDialog","LoginDialog":"LoginDialog","vendors~Comment":"vendors~Comment","Comment":"Comment","vendors~NormalTabs":"vendors~NormalTabs","vendors~SimpleGuideLayer":"vendors~SimpleGuideLayer","vendors~SlidesTabs":"vendors~SlidesTabs","vendors~pics":"vendors~pics","pics":"pics"}[chunkId]||chunkId) + "._mobile_modern." + {"0":"7393df38","1":"39223352","2":"9948d594","3":"2409ff86","4":"0e3c9747","5":"4f1bf212","6":"8ac88b1b","AccountOpening":"0a3ddef1","BackTopBottom":"479e0b88","Caption":"37524130","Copyright":"8541fae8","DataBox":"2f228197","HomeFooter":"a1f687ea","Img":"762e6d79","LivePlayer":"9947399f","MoreTabs":"cb784ea9","Nav":"4432f3f3","NormalCaption":"5aafe11c","Offline":"7743e4d6","QQShare":"b773184d","Stick":"5fc8fe75","Tip":"24d83b2a","ViewMoreLink":"2595a67c","WxLaunchApp":"c6fdd741","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"ddb2d04d","Atlas":"b124e900","FiveNavPic":"a0ca17c9","FourNavPic":"c886c8ad","ThreeNavPic":"92dd5212","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage":"3792da09","Hongbao":"6df98f50","NoImage":"5591928c","vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage":"91922873","BigImage":"95d9a269","OneImage":"46dec4c3","ThreeImage":"a0f82904","TwoImage":"b9b64f3a","vendors~NewsStream":"8cd91cf4","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"1fa86998","BrowserGuideLayer":"e13896c9","MarkTabs":"c53a1fb1","PageBottomBrand":"4b4a915a","WXGuideLayer":"52d92736","MdBanner":"49bcfab9","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"254a0ea4","BigImg":"ff4c2e6f","SingleTitle":"04e9a1f7","SlideImg":"1d31682b","TwoImg":"025958f8","vendors~BigTopic~InformationFlow~TitleImg":"1fdfc936","InformationFlow":"c3a02c0c","BigTopic":"d60299de","TitleImg":"b5247b69","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"0e3b122f","vendors~BottomSlides~UpgradeBottomSlides":"329a37e5","UpgradeBottomSlides":"5879fe88","vendors~IndexSlides":"3433534d","vendors~CallupHead":"adb34397","vendors~Comment~ShareComment":"289f229e","vendors~ShareComment":"0b2f05e5","vendors~Player":"bf164a31","vendors~Survey":"be5a2240","vendors~WxLaunchHack":"54379636","Slides":"9c708de7","vendors~NormalSlides":"b7aa9ba2","vendors~ShareSlides":"a4e59f40","vendors~CallupVideoAppHead":"60e6b944","vendors~Comment~LoginDialog":"588c0482","LoginDialog":"89ea39ab","vendors~Comment":"a7089fb0","Comment":"4aac6c6e","vendors~NormalTabs":"e7e01487","vendors~SimpleGuideLayer":"b68d51d2","vendors~SlidesTabs":"6daac6e0","vendors~pics":"90c289ca","pics":"e41d0728"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/custom/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
